import React from "react";
import { animated } from "react-spring";
import { PlacementGroup } from "../../../../SubComponents";

const bottomStyles = {
  hertz: {
    regular: "translate(-15px, 185px) scale(0.4)",
    phone: "translate(240px, 310px) scale(0.55)",
  },
  fairtrade: {
    regular: "translate(250px, 190px) scale(0.05)",
    phone: "translate(1360px, 125px) scale(0.04)",
  },
  spotify: {
    regular: "translate(442px,174px) scale(0.43)",
    phone: "translate(0, 120px) scale(0.65)",
  },
  zalando: {
    regular: "translate(-30px,455px) scale(0.35)",
    phone: "translate(1030px, 130px) scale(0.4)",
  },
  dhl: {
    regular: "translate(1350px, 30px) scale(1.85)",
    phone: "translate(880px, 330px) scale(1.85)",
  },
  nike: {
    regular: "translate(1030px, 220px) scale(1.5)",
    phone: "translate(830px, 120px) scale(1.6)",
  },
  eon: {
    regular: "translate(1210px, 270px) scale(0.65)",
    phone: "translate(1600px, 150px) scale(0.5)",
  },
  ravensburger: {
    regular: "translate(1490px, 380px) scale(1.15)",
    phone: "translate(1600px, 260px) scale(0.9)",
  },
};

const Zalando = () => (
  <PlacementGroup pos={bottomStyles.zalando}>
    <path
      d="M331.03,36.24c-11.05-6.81-57.72-5.91-61.51,4.32l1.49,7.54c0.9,3.33,4.14,2.2,6.41,1.62c8.35-2.56,31.93-6.58,42.07-2.27
	c7.38,2.22,4.43,12.23,5.02,18.26c-19.77,1.46-60.37-3.54-59.08,30.44c2.5,37.38,40.49,28.02,60.21,25.93
	c11.72-2.72,14.71-6.44,14.56-18.09C337.62,89.41,347.68,44.07,331.03,36.24 M324.6,108.59c-6.24,2.02-13.06,3.05-20.29,3.05v0.66
	l-0.01-0.66c-11.55-0.09-22.83-1.41-22.84-16.14c0.07-11.72,6.33-13.11,14.24-14.88c7.14-1.66,25.05-1.89,28.9-1.95L324.6,108.59z
	 M470.8,57.14v46.84c1.64,20.5-19.21,19.08-36.07,20.41c-41.81,7.28-58.35-51.68-9.34-56.76c12.48-1.89,21.96-1.98,29.73-1.92
	c-0.63-6.05,2.37-16.03-5.02-18.26c-10.17-4.31-33.69-0.29-42.07,2.27c-2.26,0.59-5.53,1.71-6.41-1.62l-1.49-7.54
	c2.24-7.57,21.5-7.56,37.05-8.73C457.39,30.86,473.15,38.37,470.8,57.14 M455.19,78.66c-3.86,0.07-21.75,0.29-28.91,1.95
	c-7.91,1.77-14.16,3.16-14.24,14.88c0.01,14.73,11.29,16.05,22.84,16.14l0.01,0.66v-0.66c7.23,0,14.05-1.02,20.29-3.05L455.19,78.66
	z M707.36,31.83c-36.38,0.05-39.46,23.96-39.5,46.36c0.04,22.32,3.12,46.15,39.5,46.19c36.35-0.05,39.45-23.81,39.5-46.19
	C746.82,54.76,743.74,31.88,707.36,31.83 M707.36,111.31c-22.07-0.1-23.18-11.43-23.33-33.11c0.15-21.81,1.26-33.19,23.32-33.29
	c22.07,0.1,23.18,11.48,23.33,33.28C730.53,99.88,729.43,111.21,707.36,111.31 M642.07,121.09c-6.09,1.51-12.22,3.24-25.23,3.29
	c-34.01-0.11-40.43-17.15-40.34-47.36c-3.4-43.73,30.37-50.36,61.38-42.68l-0.03-27.09c-0.04-1.19,0.5-2.74,3.31-3.28l8.94-2.28
	c7.54-2.6,1.38,102.96,3.28,105.21C653.52,113.34,652.76,118.85,642.07,121.09 M637.86,47.38c-21.01-4.2-48.22-9.17-45.35,30.81
	c0.2,31.41,9.55,33.11,24.8,33.28l0.01,0.66v-0.66c9.49,0,17.63-1.98,20.54-2.78L637.86,47.38z M557.49,122.27
	c-3.24-0.51-11.93,1.86-11.76-3.76c0,0,0-60.38,0-60.38c3.16-22.61-37.11-9.96-43.39-8.96v69.34c0.28,5.67-8.58,3.3-11.76,3.77
	c-7.9,4.14-2.08-69.8-3.77-71.49c-0.12-6.27,0.47-10.6,9.39-13.49c20.37-6.3,67.92-13.75,65.05,19.36
	C559.62,58.91,565.36,125.57,557.49,122.27 M376.33,123.9c9.16-1.25,11.49,0.12,8.67-10.64c-0.22-1.6-1.46-2.5-2.44-2.38
	c-3.46-0.18-8.54,0.53-8.35-5.43c0,0,0-100.31,0-100.31c0.05-1.9-1.4-3.71-3.52-3.43L361.74,4c-6.91-0.79-1.36,98.73-3.05,101.77
	C358.71,117.44,364.98,123.88,376.33,123.9z M249.81,122.27h-64.18c-2.14,0-3.76-1.62-3.76-3.76c0.33-3.14-1.09-9.75,1.75-12.08
	c0,0,51.09-59.39,51.09-59.39c-2.69-1.61-56.23,4.02-53.82-3.76c0.17-3.05-1.12-9.46,3.76-9.31c2.12,1.66,72.19-4.12,68.6,3.76
	c-0.45,3.03,1.17,9.6-1.62,11.96c0,0-51.22,59.51-51.22,59.51c2.86,1.61,55.43-4.02,53.17,3.76
	C253.45,116,254.66,122.41,249.81,122.27"
    />
    <path
      fill="#FF6900"
      d="M136.61,57.74C113.92,30.06,56.76-7.05,20.42,2.27C-5.62,18.33-11.11,160.05,37.83,146.51
	C64.92,145.31,170.38,92.28,136.61,57.74z"
    />
  </PlacementGroup>
);

const Fairtrade = () => (
  <PlacementGroup pos={bottomStyles.fairtrade}>
    <path fill="#010202" d="M0.19,0.06V2499h2103.9V0.04L0.19,0.07V0.06z" />
    <path
      fill="#CDD42A"
      d="M149.68,1050.67c0-240.18,94.74-458.09,248.32-620.08c-19.59,50.42-47.06,139.68-47.06,245.72
	c0,120.89,35.66,263.06,159.3,393.46l22.71,23.94c176.35,185.73,334.75,352.47,334.75,574.6c0,75.85-18.72,158.26-61.44,250.04
	c-378.34-107.54-656.56-455.33-656.56-867.71"
    />
    <path
      fill="#00B0DB"
      d="M1189.92,974.88c-131.42,0-237.77-106.4-237.77-237.82c0-131.23,106.35-237.73,237.77-237.73
	c131.31,0,237.77,106.5,237.77,237.73C1427.68,868.47,1321.23,974.88,1189.92,974.88 M1954.74,1050.67c0-8.06-0.35-16.16-0.59-24.24
	l0.19-0.04c0-484.19-391.32-877.82-875.53-877.82c-6.65,0-24.59,0.56-24.59,0.56c-70.45,2.43-141.06,15.01-198.84,32.72
	c-27.04,8.26-123.14,41.25-193.53,113.11c-76.91,79.19-119.85,185.28-119.68,295.68c0,187.51,115.71,332.45,289.77,403.17
	c74.79,29.53,156.51,47.99,216.46,62.61c104.32,25.44,323.89,62.07,506.66,182.81l6.95,4.46
	c114.26,78.04,183.18,187.58,183.18,373.38c0,3.6-0.15,7.34-0.15,11.05c130.75-156.68,209.68-357.99,209.68-577.44"
    />
    <path
      fill="#FFFFFF"
      d="M847.92,2126.19h72.25v221.78h44.22v-221.78h73.83v-39.65H847.92L847.92,2126.19z M766.95,2206.05
	c-10.98,5.74-23.14,6.24-28.71,6.43c-9.45,0.54-15.99,0.8-33.04,0.8h-20.26v-89.26h25.95c29.42,0,42.75,0.22,54.29,5.89
	c21.86,11.12,22.79,32,22.73,38.19h-0.37l0.37,0.43v0.07C787.95,2188.84,778.05,2200.39,766.95,2206.05 M780.65,2240.06l1.6-0.52
	c14.69-4.53,50.61-21.32,50.61-70.65c-0.07-30.33-12.41-50.52-28.38-63.69c-22.66-18.2-45.47-18.28-81.16-18.67h-82.24v261.43h43.83
	v-99.12h49.22l52.97,99.12h50.61l-58.8-107.42L780.65,2240.06z M1194.64,2206.07c-11.09,5.76-23.29,6.22-28.86,6.41
	c-9.38,0.56-15.97,0.8-32.95,0.8h-20.36l0.02-86.53v-2.73h26.02c29.44,0,42.7,0.22,54.29,5.89c21.73,11.07,22.75,31.72,22.66,38.06
	h-0.09l0.09,0.56v0.07c0.09,20.26-9.75,31.8-20.84,37.48 M1208.27,2240.06l1.67-0.56c14.62-4.49,50.52-21.28,50.52-70.61
	c0-30.31-12.31-50.52-28.42-63.67c-22.66-18.2-45.39-18.28-81.01-18.67h-82.41v261.43h43.83v-99.14h49.18l53.12,99.14h50.48
	l-58.71-107.42l1.76-0.5L1208.27,2240.06z M1709.45,2220.37c0.07,55.85-21.47,74.36-41.7,82.05c-11.83,4.36-25.54,6.28-63.43,6.28
	h-24.01v-182.53h29.31c33.58,0.41,42.31,0.84,57.28,7.56c38.74,18.7,42.55,61.05,42.55,86.18
	C1709.45,2220.1,1709.39,2220.28,1709.45,2220.37 M1706.35,2106.86c-27.19-19.54-54.4-19.91-77.41-20.3h-92.86v261.43h82.69
	c31.39-0.37,58.78-0.74,84.49-15.88c38.07-21.97,53.41-67.38,53.41-112.55C1756.66,2189.99,1749.86,2137.28,1706.35,2106.86
	 M1976.08,2125.45v-38.91h-184.31v261.43h183.7v-39.28h-140.19v-77.3h128.67v-37.37h-128.67v-68.57H1976.08z M1357.07,2258.02
	l40.9-135.91l40.53,135.91H1357.07z M1370.85,2086.54l-88.13,261.43h47.27l15.47-52.26l104.58,0.04l15.49,52.23h47.19l-89.24-261.43
	H1370.85z M437.58,2258.02h-81.65l41.01-136.01l39.43,132.16L437.58,2258.02z M369.92,2086.52l-88.22,261.47H329l15.51-52.26H449
	l15.6,52.26h47.17l-89.2-261.43l-52.65-0.02L369.92,2086.52z M169.33,2125.45h127.15v-38.91H125.43v261.43h43.92v-113.14h111.62
	v-37.02H169.35v-72.36H169.33z M543.24,2086.54v261.43h43.42v-261.43H543.24z"
    />
  </PlacementGroup>
);

const Dhl = () => (
  <PlacementGroup pos={bottomStyles.dhl}>
    <path fill="#D40511" d="M0,18.5h17.4l-1,1.4H0V18.5z" />
    <path fill="#D40511" d="M143.5,19.9h-21.3l1.1-1.4h20.3v1.4H143.5z" />
    <path fill="#D40511" d="M0,15.9h19.4l-1.1,1.4H0V15.9z" />
    <path fill="#D40511" d="M0,13.3h21.4l-1.1,1.4H0V13.3z" />
    <path fill="#D40511" d="M143.5,17.3h-19.3l1.1-1.4h18.3v1.4H143.5z" />
    <path fill="#D40511" d="M127.2,13.3h16.3v1.4h-17.4L127.2,13.3z" />
    <path
      fill="#D40511"
      d="M18.8,19.9L28,7.6c0,0,10.2,0,11.4,0c1.3,0,1.3,0.5,0.6,1.3c-0.6,0.8-1.7,2.3-2.3,3.1c-0.3,0.5-0.9,1.2,1,1.2
	c2.1,0,15.3,0,15.3,0C52.8,15,48.6,20,41.2,20C35.2,19.9,18.8,19.9,18.8,19.9z"
    />
    <path fill="#D40511" d="M71.5,13.3l-5,6.7H53.4l5-6.7H71.5z" />
    <path fill="#D40511" d="M90.6,13.3l-5,6.7H72.4l5-6.7H90.6z" />
    <path
      fill="#D40511"
      d="M94.9,13.3c0,0-1,1.3-1.4,1.9c-1.7,2.2-0.2,4.8,5.2,4.8c6.2,0,21.2,0,21.2,0l5-6.7H94.9z"
    />
    <path
      fill="#D40511"
      d="M25.3,0l-4.6,6.1c0,0,23.7,0,25,0c1.3,0,1.3,0.5,0.6,1.3c-0.6,0.8-1.7,2.3-2.3,3.1c-0.3,0.4-0.9,1.2,1,1.2
	c2.1,0,10.2,0,10.2,0s1.7-2.2,3-4.1c1.9-2.5,0.2-7.7-6.5-7.7C45.7,0,25.3,0,25.3,0z"
    />
    <path
      fill="#D40511"
      d="M91.7,11.7H59.5L68.3,0h13.2l-5,6.7h5.9l5-6.7h13.2L91.7,11.7z"
    />
    <path fill="#D40511" d="M118.8,0L110,11.7H96L104.8,0H118.8z" />
  </PlacementGroup>
);

const Spotify = () => (
  <PlacementGroup pos={bottomStyles.spotify}>
    <path
      fill="#1ED760"
      d="M87.996 1.277c-46.249 0-83.743 37.493-83.743 83.742 0 46.254 37.494 83.745 83.743 83.745 46.251 0 83.743-37.491 83.743-83.745 0-46.25-37.492-83.742-83.743-83.742zm38.405 120.787a5.217 5.217 0 0 1-7.177 1.737c-19.665-12.019-44.417-14.734-73.567-8.075a5.217 5.217 0 0 1-6.249-3.925 5.212 5.212 0 0 1 3.926-6.249c31.9-7.293 59.263-4.154 81.336 9.334a5.22 5.22 0 0 1 1.731 7.178zm10.247-22.803c-1.894 3.073-5.912 4.037-8.981 2.15-22.505-13.834-56.822-17.841-83.447-9.759-3.453 1.043-7.1-.903-8.148-4.35a6.538 6.538 0 0 1 4.354-8.143C70.842 69.93 108.652 74.4 134.5 90.285c3.069 1.89 4.035 5.91 2.148 8.976zm.884-23.744c-26.994-16.031-71.52-17.505-97.289-9.684-4.138 1.255-8.514-1.081-9.768-5.219a7.835 7.835 0 0 1 5.221-9.771c29.581-8.98 78.756-7.245 109.832 11.202a7.833 7.833 0 0 1 2.737 10.733c-2.209 3.722-7.02 4.949-10.733 2.739zm94.557 3.069c-14.459-3.448-17.033-5.868-17.033-10.953 0-4.804 4.523-8.037 11.249-8.037 6.52 0 12.985 2.455 19.763 7.509a.945.945 0 0 0 .715.174.934.934 0 0 0 .625-.386l7.06-9.952a.949.949 0 0 0-.18-1.288c-8.067-6.473-17.151-9.62-27.769-9.62-15.612 0-26.517 9.369-26.517 22.774 0 14.375 9.407 19.465 25.663 23.394 13.836 3.187 16.171 5.857 16.171 10.63 0 5.289-4.722 8.577-12.321 8.577-8.44 0-15.324-2.843-23.025-9.512a.992.992 0 0 0-.695-.226.94.94 0 0 0-.65.334l-7.916 9.421a.94.94 0 0 0 .094 1.313c8.96 7.999 19.98 12.224 31.872 12.224 16.823 0 27.694-9.192 27.694-23.419 0-12.023-7.184-18.673-24.8-22.957zm62.861-14.26c-7.292 0-13.273 2.872-18.205 8.757v-6.624a.949.949 0 0 0-.946-.949h-12.947a.948.948 0 0 0-.946.949v73.602c0 .523.423.949.946.949h12.947a.949.949 0 0 0 .946-.949v-23.233c4.933 5.536 10.915 8.241 18.205 8.241 13.549 0 27.265-10.43 27.265-30.368 0-19.942-13.716-30.375-27.265-30.375zm12.212 30.375c0 10.153-6.254 17.238-15.209 17.238-8.853 0-15.531-7.407-15.531-17.238 0-9.83 6.678-17.238 15.531-17.238 8.811 0 15.209 7.248 15.209 17.238zm50.211-30.375c-17.449 0-31.119 13.436-31.119 30.592 0 16.969 13.576 30.264 30.905 30.264 17.511 0 31.223-13.391 31.223-30.481 0-17.033-13.618-30.375-31.009-30.375zm0 47.719c-9.281 0-16.278-7.457-16.278-17.344 0-9.929 6.755-17.134 16.064-17.134 9.341 0 16.385 7.457 16.385 17.351 0 9.927-6.801 17.127-16.171 17.127zm68.271-46.535h-14.247V50.944a.947.947 0 0 0-.945-.948h-12.945a.95.95 0 0 0-.949.948V65.51h-6.225a.947.947 0 0 0-.943.949v11.127c0 .522.422.949.943.949h6.225v28.791c0 11.635 5.791 17.534 17.212 17.534 4.644 0 8.497-.959 12.128-3.018a.944.944 0 0 0 .478-.821v-10.596a.948.948 0 0 0-1.372-.85c-2.494 1.255-4.905 1.834-7.6 1.834-4.154 0-6.007-1.886-6.007-6.113V78.534h14.247a.946.946 0 0 0 .944-.949V66.459a.946.946 0 0 0-.944-.949zm49.637.057v-1.789c0-5.263 2.018-7.61 6.544-7.61 2.699 0 4.867.536 7.295 1.346a.946.946 0 0 0 1.245-.902v-10.91a.947.947 0 0 0-.67-.909c-2.565-.763-5.847-1.546-10.761-1.546-11.958 0-18.279 6.734-18.279 19.467v2.74h-6.22a.952.952 0 0 0-.95.948v11.184c0 .522.428.949.95.949h6.22v44.409c0 .523.422.949.944.949h12.947a.95.95 0 0 0 .949-.949v-44.41h12.088l18.517 44.398c-2.102 4.665-4.169 5.593-6.991 5.593-2.281 0-4.683-.681-7.139-2.025a.972.972 0 0 0-.754-.071.957.957 0 0 0-.56.511l-4.388 9.627a.942.942 0 0 0 .408 1.225c4.581 2.481 8.716 3.54 13.827 3.54 9.56 0 14.844-4.453 19.502-16.433l22.461-58.04a.947.947 0 0 0-.879-1.293h-13.478a.951.951 0 0 0-.897.636l-13.807 39.438-15.123-39.464a.945.945 0 0 0-.884-.61h-22.117zm-28.776-.057h-12.947a.95.95 0 0 0-.949.949v56.485a.95.95 0 0 0 .949.949h12.947a.951.951 0 0 0 .949-.949V66.459a.952.952 0 0 0-.949-.949zm-6.408-25.719c-5.129 0-9.291 4.152-9.291 9.281 0 5.132 4.163 9.289 9.291 9.289 5.127 0 9.285-4.157 9.285-9.289 0-5.128-4.158-9.281-9.285-9.281z"
    />
    <path
      fill="#1ED760"
      d="M553.519 83.671c-5.124 0-9.111-4.115-9.111-9.112s4.039-9.159 9.159-9.159a9.074 9.074 0 0 1 9.111 9.107c0 4.997-4.036 9.164-9.159 9.164zm.048-17.365c-4.667 0-8.198 3.71-8.198 8.253 0 4.541 3.506 8.201 8.151 8.201 4.666 0 8.201-3.707 8.201-8.253-.001-4.541-3.51-8.201-8.154-8.201zm2.02 9.138l2.577 3.608h-2.173l-2.32-3.31h-1.995v3.31h-1.819v-9.564h4.265c2.222 0 3.683 1.137 3.683 3.051.001 1.568-.905 2.526-2.218 2.905zm-1.538-4.315h-2.372v3.025h2.372c1.184 0 1.891-.579 1.891-1.514 0-.984-.707-1.511-1.891-1.511z"
    />
  </PlacementGroup>
);

const Nike = () => (
  <PlacementGroup pos={bottomStyles.nike}>
    <path
      d="M19,36.9c-2.8-0.1-5.1-0.9-7-2.3c-0.3-0.3-1.2-1.1-1.4-1.4c-0.7-0.9-1.2-1.8-1.6-2.8c-1-3.1-0.5-7.1,1.5-11.5
	c1.7-3.8,4.4-7.5,9-12.7c0.7-0.8,2.7-3,2.7-3c0,0-0.1,0.2-0.2,0.4c-1.2,2-2.2,4.4-2.8,6.4c-0.9,3.3-0.8,6.1,0.3,8.3
	c0.8,1.5,2.1,2.8,3.6,3.5c2.6,1.3,6.4,1.4,11,0.3c0.3-0.1,16.1-4.3,35-9.3c18.9-5,34.5-9.2,34.5-9.2c0,0-44,18.8-66.9,28.6
	c-3.6,1.5-4.6,1.9-6.3,2.5C26,36.3,22.1,37,19,36.9L19,36.9z"
    />
  </PlacementGroup>
);

const Ravensburger = () => (
  <PlacementGroup pos={bottomStyles.ravensburger}>
    <path fill="#1A5DAE" d="M126.3,11.8L11.8,126.3h114.5V11.8z" />
    <path
      fill="#FFFFFF"
      d="M112.2,38.2c-0.3,0.3-0.4,0.3-0.6,0.5c-0.6,0.6-1,1.7-0.4,3l0,0l-1.2-1.1l-1.7,1.7
		c0.6,0.5,1.2,1.1,2.1,2l4.1,4.1l1.9-1.9l-3.1-3.1c-0.2-0.2-0.3-0.3-0.4-0.5c-0.5-0.7-0.4-1.6,0.3-2.3c0.2-0.2,0.4-0.4,0.7-0.6
		L112.2,38.2z M107.5,44.3c-0.9,0-1.8,0.3-2.7,1.2c-2.1,2.1-1.4,4.8,0.2,6.4c1.9,1.9,4.3,2,6.4-0.1c0.8-0.8,1.5-1.7,1.9-2.6l-1.6-1
		c-0.3,0.7-0.8,1.3-1.4,2c-0.9,0.9-2.1,1.3-2.9,0.6l4-3.9c-0.1-0.2-0.4-0.5-0.7-0.8C109.8,45,108.7,44.3,107.5,44.3z M107,46.4
		c0.5,0,1,0.3,1.3,0.6l-2.3,2.3c-0.5-0.6-0.9-1.6-0.1-2.5C106.3,46.6,106.6,46.4,107,46.4z M101.3,49.3L99.6,51l0.7,0.8l0,0
		c-0.8-0.2-1.7,0-2.6,0.8c-1.5,1.5-1.5,4.1,0.5,6.1c1.8,1.8,4.1,1.9,5.6,0.4c0.7-0.7,1-1.6,0.9-2.5l0,0l0.4,0.4
		c1.1,1.1,0.9,2.3,0,3.2c-0.7,0.7-1.6,1.2-2.3,1.3l1.1,1.8c0.9-0.2,1.9-0.9,2.7-1.7c0.9-0.9,1.7-2,1.8-3.3c0.1-1.3-0.6-2.5-1.8-3.7
		l-3.4-3.4C102.1,50.3,101.6,49.8,101.3,49.3z M100.4,53.3c0.3,0,0.7,0.1,1,0.2c0.1,0.1,0.3,0.2,0.4,0.3l0.9,0.9
		c0.2,0.2,0.4,0.4,0.5,0.6c0.3,0.6,0.3,1.3-0.2,1.8c-0.8,0.8-2,0.5-2.9-0.4c-1.1-1.1-1.2-2.3-0.5-3C99.8,53.4,100.1,53.3,100.4,53.3z
		M94.7,55.7c-0.2,0.1-0.3,0.2-0.4,0.4c-0.6,0.6-1,1.7-0.4,3L93.8,59L92.6,58L91,59.6c0.6,0.5,1.2,1.1,2.1,2l4.1,4.2l1.9-1.9L96,60.7
		c-0.2-0.2-0.3-0.3-0.4-0.5c-0.5-0.7-0.3-1.6,0.4-2.3c0.2-0.2,0.4-0.3,0.6-0.5L94.7,55.7z M90.1,60.5l-1.9,1.9l3.7,3.7
		c0.2,0.2,0.3,0.3,0.3,0.5c0.2,0.4,0.2,1.1-0.3,1.6c-0.7,0.7-1.5,0.4-2.4-0.5l-3.3-3.3l-1.9,1.9l3.6,3.6c1.9,1.9,3.6,1.8,4.9,0.5
		c1.1-1.1,1.1-2.3,0.9-2.9l0,0l1,0.8l1.7-1.7c-0.5-0.5-1.2-1.1-2-1.9L90.1,60.5z M83.2,68.4c-0.9,0-1.7,0.4-2.3,1
		c-0.9,0.9-1.2,1.8-1,2.7l0,0l-3.1-3.1L74.9,71l6.7,6.7c0.7,0.7,1.4,1.5,1.8,1.9l1.6-1.6L84.2,77l0,0c1.2,0.3,2.1-0.1,2.9-0.9
		c1.4-1.4,1.7-3.9-0.5-6.2C85.5,68.9,84.3,68.4,83.2,68.4z M82.8,71.1c0.6,0,1.3,0.3,1.9,0.9c1.1,1.1,1.3,2.3,0.4,3.1
		c-0.6,0.6-1.4,0.6-2.1,0.2c-0.1-0.1-0.3-0.2-0.4-0.3l-0.9-0.9c-0.1-0.1-0.2-0.3-0.3-0.4c-0.4-0.7-0.3-1.5,0.2-2.1
		C82,71.3,82.4,71.1,82.8,71.1z M76.5,74.5c-0.6,0.2-1.5,0.7-2.3,1.5c-1.7,1.7-1.9,3.6-0.7,4.8c0.7,0.7,2,0.9,3.8-0.1
		c1-0.5,1.4-0.6,1.7-0.3c0.3,0.3,0.2,0.8-0.4,1.5C78,82.5,77,83,76.4,83.2l1,1.8c0.8-0.3,1.7-0.9,2.6-1.8c1.9-1.9,2.1-3.8,0.9-4.9
		c-0.9-0.9-2-1-3.7-0.1c-1.1,0.6-1.6,0.7-1.9,0.4c-0.3-0.3-0.2-0.8,0.3-1.3c0.6-0.6,1.4-1,1.8-1.1L76.5,74.5z M70.5,80.8
		c-0.7,0-1.4,0.4-1.9,0.9c-1,1-1.1,2.3-0.9,2.9l0,0l-0.9-0.8L65,85.6c0.6,0.5,1.3,1.2,2,1.9l4.2,4.2l1.9-1.9l-3.6-3.6
		c-0.2-0.2-0.3-0.4-0.4-0.5c-0.2-0.5-0.3-1.2,0.2-1.7c0.7-0.7,1.5-0.4,2.3,0.4l3.4,3.4l1.9-1.9l-3.7-3.6
		C72.4,81.2,71.4,80.8,70.5,80.8z M64.2,87.6c-0.9,0-1.8,0.3-2.7,1.2c-2.1,2.1-1.4,4.8,0.2,6.4c1.9,1.9,4.3,1.9,6.4-0.2
		c0.8-0.8,1.5-1.7,1.9-2.6l-1.6-1.1c-0.3,0.7-0.8,1.3-1.4,2c-0.9,0.9-2.1,1.3-2.9,0.6l4-3.9c-0.1-0.2-0.4-0.5-0.7-0.9
		C66.5,88.3,65.3,87.7,64.2,87.6z M63.6,89.8c0.5,0,1,0.3,1.3,0.6l-2.3,2.3c-0.5-0.6-0.9-1.6-0.1-2.5C63,89.9,63.3,89.8,63.6,89.8z
		M58.8,91.8l-2,2l2.1,3.7c0.4,0.7,0.7,1.2,1.2,1.8l0,0c-0.6-0.4-1.2-0.8-1.9-1.1l-3.7-2.1l-2.1,2.1l8.4,3.9l1.9-1.9L58.8,91.8z
		M52,99.5c-0.8,0-1.7,0.4-2.6,1.3c-1.1,1.1-1.7,2.3-1.9,3.1l1.6,0.9c0.2-0.8,0.7-1.7,1.3-2.3c1-1,1.6-0.7,1.9-0.3l0.1,0.1
		c-2.2,2.2-2.9,4.4-1.3,6c1,1,2.6,1.2,3.9-0.1c0.7-0.7,1.1-1.6,1-2.5l0,0l0.7,0.5l1.7-1.7c-0.4-0.3-1-0.8-1.6-1.4l-2.2-2.2
		C54,100,53.1,99.5,52,99.5z M44.1,103.4c-0.1,0-0.2,0-0.3,0c-1.2,0.2-2.3,1-3.7,2.4c-1.1,1.1-2,2.1-2.5,2.9l8.4,8.4l1.9-1.9
		l-3.3-3.3l0.7-0.7c0.9-0.9,1.7-1.1,3-0.3c1.3,0.8,2.2,1.2,2.6,1.3l2-2c-0.5-0.1-1.9-1-3.2-1.7c-1-0.5-1.8-0.8-2.7-0.4l0,0
		c0.5-1.1,0.6-2.6-0.5-3.7C45.5,103.6,44.8,103.3,44.1,103.4z M53.7,103.4l0.7,0.7c0.1,0.1,0.2,0.2,0.3,0.4c0.3,0.5,0.2,1.2-0.3,1.7
		c-0.4,0.4-1,0.5-1.5,0C52.1,105.5,52.7,104.4,53.7,103.4z M43.6,106c0.4,0,0.7,0.2,1,0.5c0.7,0.7,0.5,1.9-0.5,3l-0.9,0.9l-2.4-2.4
		c0.1-0.2,0.5-0.6,1-1.1C42.3,106.4,43,106,43.6,106z"
    />
  </PlacementGroup>
);

const Hertz = () => (
  <PlacementGroup pos={bottomStyles.hertz}>
    <polygon
      fill="#FFD100"
      points="353.66 134.36 0 134.36 4.06 115.24 357.74 115.23 353.66 134.36"
    />
    <path d="m268.87,82.36c-5.24-6.2,5.14-34.84,5.87-43.76h22.69l4.11-19.32h-22.71L282.86,0h-21.39s-14.02,66.32-14.02,66.32c-6.7,23.8,5.84,43.23,36.34,36.5l3.82-17.93c-11.72,1.45-16.43-.07-18.74-2.53Z" />
    <polygon points="87.71 0 77.5 47.9 39.96 47.9 50.14 0 28.55 0 6.72 102.82 28.29 102.82 35.83 67.19 73.39 67.19 65.83 102.82 87.23 102.82 109.08 0 87.71 0" />
    <path d="m210.97,26.54c-16.43,11.05-19.48,58.08-24.89,76.27h21.41c3.6-11.94,8.13-51.41,15.79-59.63,4.9-5.01,12.01-5.29,20.54-4.58l4.12-19.32c-15.05-3.82-28.19-.07-36.97,7.26Z" />
    <polygon points="378.08 19.28 311.25 19.28 307.16 38.6 345.93 38.6 297.44 84.24 293.5 102.82 360.32 102.82 364.44 83.51 325.45 83.51 374.18 37.66 378.08 19.28" />
    <path d="m152.54,17.75c-67.37,5.29-60.59,124.4,22.6,75.63l-8.51-14.38c-7.12,5.48-42.99,17.39-39.21-11.68h56.07c6.77-20.34,1.17-50.23-30.95-49.57Zm13.92,31.87h-34.32c3.78-16.96,36.39-22.12,34.32,0Z" />
  </PlacementGroup>
);

const Eon = () => (
  <PlacementGroup pos={bottomStyles.eon}>
    <path
      fill="#EA1C0A"
      d="M249.62,27.51c0,8.35-9.93,36.93-11.56,41.22c-1.07,2.82-3.12,3.22-5.78,3.22c-4.81,0-8.44-1.14-10.21-2.56
	c-0.37-0.29-0.82-0.92-0.51-1.83c1.81-5.39,8.67-24.8,8.67-28.99c0-2.3-0.68-4.02-2.97-4.02c-13.9,0-39.42,29.65-44.16,34.95
	c-1.55,1.73-3.82,2.1-6.48,2.1c-3.29,0-6.79-1.74-7.12-1.92c-1.04-0.54-1.09-1.13-0.78-2.38l0.87-3.55
	c1.6-6.49,9.87-30.51,15.6-43.53c0.24-0.55,0.48-1.01,1.73-1.2c0.58-0.09,2.48-0.53,5.12-0.53c1.94,0,5.7,0.14,7.59,1.15
	c0,0,0.01-0.03,0.01,3.14c0,1.37,0.15,6.02,4.53,6.02c7.39,0,20.81-12.68,32.67-12.68C247.26,16.1,249.62,22.54,249.62,27.51
	 M102.06,38.01c0,1.73-2.02,6.5-2.3,7.21c-1.82,4.48-6.57,5.2-9.92,5.2c-5.03,0-6.75-1.81-6.75-4.65c0-2.2,1.86-6.01,2.1-6.57
	c2.26-5.19,6.31-5.75,10.31-5.75C98.88,33.44,102.06,34.85,102.06,38.01 M59.08,27.05c0-3.3-0.16-8.03-2.74-8.03
	c-8.4,0-23.16,12.85-24.64,14.33c-1.09,1.1-0.28,1,1.19,1h18.89C58.48,34.35,59.08,33.23,59.08,27.05 M79.25,28.79
	c0,16.17-9.95,19.53-20.99,19.53h-7.76c-7.75,0-23.36-0.46-23.36-0.46c-1.25-0.03-2.19-0.28-2.19,0.46
	c0,5.27,5.97,13.23,15.06,13.23c7.16,0,11.77-4.47,12.78-5.53c0,0,8.22-0.95,13.5-0.95c5.13,0,12.68,0.82,12.68,3.74
	c0,5.7-18.51,14.69-34.04,14.69C21.56,73.5,0.5,60.8,0.5,45.49C0.5,19.83,50.02,0.5,64.47,0.5C77.47,0.5,79.25,21.22,79.25,28.79
	 M141.3,28.24c-1.76,0-4.38,0.27-5.57,1.92c-4.45,6.16-7.39,21.54-7.39,25.83c0,2.92,2.03,2.74,4.74,2.74
	c1.58,0,4.13,0.04,5.57-1.46c3.9-4.07,7.27-22.5,7.27-25.83C145.93,29.06,145.76,28.24,141.3,28.24 M170.68,27.42
	c0,7.02-6.94,22.45-9.16,26.74c-9.32,17.92-21.77,17.79-35.82,17.79c-6.87,0-22.17,0.08-22.17-12.78c0-5.75,5.01-16.29,9.12-26.28
	c1.75-4.25,9.2-18.52,34.58-18.52C157.7,14.37,170.68,16.01,170.68,27.42"
    />
  </PlacementGroup>
);

const LogosLayerBottom = (props) => (
  <animated.g {...props}>
    <Hertz />
    <Fairtrade />
    <Spotify />
    <Zalando />
    <Dhl />
    <Nike />
    <Eon />
    <Ravensburger />
  </animated.g>
);
export default LogosLayerBottom;
